// Ícone SVG inline da bandeira Sorocred (sem requisição HTTP)
import * as React from 'react';

export function SorocredIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Sorocred" {...props}>
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#E5E7EB" />
      <text
        x="24"
        y="15"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="7"
        fill="#1F4E9D"
      >
        Soro
      </text>
      <text
        x="24"
        y="23"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="800"
        fontSize="7"
        fill="#E30613"
      >
        cred
      </text>
    </svg>
  );
}
